import React, { useState } from "react";
import MONITORDASHBOARD from "../assets/images/monitor-dashboard.png";
import WIICOINONE from "../assets/images/coin-one.png";
import Footer from "../components/Footer";
import Header from "../components/Header";
import Icon from "../components/icons/Icon";
import Contact from "./Contact";
import OptionModal from "../components/OptionsModal";

export const Cripto = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);

  return (
    <div className="flex flex-col w-full ">
      <div
        className="flex flex-col p-3  justify-center items-center  lg:min-w-[1024px]"
        style={{
          backgroundImage:
            "radial-gradient(circle at 10%, rgba(21, 83, 224, 1) 5%, rgba(8, 21, 51, 0.8) 40%, rgba(8, 21, 51, 0.5) 80%), radial-gradient(circle at 30% 50%, rgba(21, 83, 224, 0.6) 10%, rgba(8, 21, 51, 0.8) 50%, rgba(8, 21, 51, 0.3) 80%), radial-gradient(circle at 70% 70%, rgba(21, 83, 224, 0.7) 10%, rgba(8, 21, 51, 0.8) 50%, rgba(8, 21, 51, 0.4) 100%)",
          position: "relative",
        }}
      >
        <Header />
        <div className="flex flex-row p-3 mt-8 lg:mt-15 py-2 items-center w-fit lg:w-[900px]">


        <div className="hidden lg:block flex flex-col items-right justify-right lg:w-[420px] w-fit " >
        <img
                src={MONITORDASHBOARD}
                alt="Imagem monitor com dashboard"
                className="w-[420px] h-auto rounded-xl items-right "
              />
        </div>
        <div className="flex flex-col items-center w-fit lg:w-[400px] text-left  lg:ml-10">
          
          <div>
          <h2 className="text-4xl font-bold text-white text-center lg:text-left  mb-6">
            O futuro é 
            <br /> <span className="text-[#887443]">descentralizado</span>,
            <br />Invista com segurança.
          </h2>
          </div>
          <div className="block lg:hidden md:hidden flex flex-col items-right justify-right lg:w-[420px] w-fit " >
        <img
                src={MONITORDASHBOARD}
                alt="Imagem monitor com dashboard"
                className="w-[220px] h-auto rounded-xl items-right "
              />
        </div>


          <div>
          <p className="text-xl text-center lg:text-left  w-fit text-white/80 mb-6 ml-4 mr-3 ml-4">
          Nossa plataforma une segurança, simplicidade e inovação para que você explore o universo das criptomoedas com total confiança.
          <br />
          </p>
          </div>
          <div>
          <p className="text-xl text-center lg:text-left  w-fit text-white/80 mb-6 mr-2 ml-4">
          Na Wii Ascend, o seu dinheiro vai além dos limites. É você no controle, com liberdade real para investir no que acredita.
          </p>
          </div>

          {/* <div className="flex justify-center gap-4">
            <button className="bg-[#0E2D60] text-white py-2 px-6 rounded-full ">
              Entre em contato
            </button>
            <button className="bg-[#887443] text-white py-2 px-6 rounded-full ">
              Saiba Mais
            </button>
          </div> */}
        </div>
        </div>

        <div className="flex justify-center w-fit lg:w-[900px] items-center p-2 lg:p-20">
          <div className="flex flex-col justify-center items-center  py-0 px-8 rounded-2xl">
          <div className="block lg:hidden flex mb-8 items-center w-fit justify-center lg:justify-left lg:items-left lg:mb-0">
                <img
                  src={WIICOINONE}
                  alt="Imagem wii coin"
                  className="w-[250px] h-auto rounded-xl items-center"
                />
              </div>

            <h2 className="text-5xl text-center lg:text-left font-bold text-white mb-6">
              Conheça a Wii Coin
            </h2>

            <p className="text-xl text-white/80 mb-8 text-center font-light">
              Criar um ativo digital não é apenas sobre inovação. É sobre
              <br/>  oferecer mais controle e oportunidades para nossos clientes.
            </p>

            <div className="flex flex-col items-center lg:flex-row gap-4 mb-10 lg:mb-1">
              <div className="hidden lg:block flex mb-8 items-center w-fit justify-center lg:justify-left lg:items-left lg:mb-0">
                <img
                  src={WIICOINONE}
                  alt="Imagem wii coin"
                  className="w-[250px] h-auto rounded-xl items-center"
                />
              </div>
              <div className="flex flex-col items-center gap-4">
                <div className="flex flex-row items-center gap-2 bg-white lg:w-100 text-[#081533] text-xl py-2 px-6 rounded-full hover:bg-[#7A5F22] w-full ">
                  <Icon name="Arrow" className="w-5 h-5 " />
                  Transações seguras
                </div>
                <div className="flex flex-row items-center gap-2 bg-white lg:w-100 text-[#081533] text-xl py-2 px-6 rounded-full hover:bg-[#7A5F22] w-full ">
                  <Icon name="Arrow" className="w-5 h-5" />
                  Alta eficiência
                </div>
                <div className="flex flex-row items-center gap-2 bg-white lg:w-100 text-[#081533] text-xl py-2 px-6 rounded-full hover:bg-[#7A5F22] w-full ">
                  <Icon name="Arrow" className="w-5 h-5" /> Facilidade em
                  operações de alto nível
                </div>
                <div className="flex flex-row items-center gap-2 bg-white lg:w-100 text-[#081533] text-xl py-2 px-6 rounded-full hover:bg-[#7A5F22] w-full ">
                  <Icon name="Arrow" className="w-5 h-5" /> Nova oportunidade de
                  investimento
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="flex flex-col  w-fit lg:w-[900px] justify-center items-center">
          <h2 className="text-2xl ml-4 mr-4 br-2 lg:ml-0 lg:mr-0 lg:text-5xl font-bold text-white mb-6 text-center">
            Descubra o universo das criptomoedas <br /> com a Wii Ascend {" "}
            <span className="text-[#887443]">
            — uma exchange <br /> completa, intuitiva e segura
            </span>
          </h2>

          <p className="text-lg ml-8 mr-8 text-white/95 mb-5 lg:mb-12 text-center">
            Compre, venda, troque, transfira e receba uma ampla variedade de 
            <br/> criptativos, como{" "}
            <span className="font-semibold">
              Bitcoin (BTC), Tether (USDT) e USD Coin 
              <br/> (USDC), e muitas outros.
            </span>
          </p>

          <div className="flex flex-col gap-8 w-fit p-8 lg:p-0 lg:w-full">
            <div className="flex flex-col lg:flex-row gap-8">
              <div className="bg-[#FAFAFA]/10 lg:h-40 lg:w-[800px] border-l-20 border-[#887443] text-white p-6 rounded-xl">
                <h3 className="text-xl font-semibold mb-4">
                  Taxas justas e suporte especializado:
                </h3>
                <p className="text-lg text-white/80">
                É a escolha ideal para quem busca liberdade financeira com confiança e transparência.
                </p>
              </div>
              <div className="bg-[#FAFAFA]/10  lg:h-40 lg:w-[800px] border-l-20 border-[#887443] text-white p-6 rounded-xl">
                <h3 className="text-xl font-semibold mb-4">
                  Staking e rendimentos passivos:
                </h3>
                <p className="text-lg text-white/80">
                Coloque suas criptos para trabalhar e obtenha recompensas sem esforço.
                </p>
              </div>
              
            </div>

            <div className="flex flex-col lg:flex-row gap-8">
            <div className="bg-[#FAFAFA]/10 lg:h-40 lg:w-[800px] border-l-20 border-[#887443] text-white p-6 rounded-xl">
                <h3 className="text-xl font-semibold mb-4">
                  Pagamentos com criptomoedas:
                </h3>
                <p className="text-lg text-white/80">
                  Pague produtos e serviços utilizando ativos digitais de forma
                  simples.
                </p>
              </div>
             

              <div className="bg-[#FAFAFA]/10 lg:h-40 lg:w-[800px] border-l-20 border-[#887443] text-white p-6 rounded-xl">
                <h3 className="text-xl font-semibold mb-4">
                  Integração com carteiras e bancos:
                </h3>
                <p className="text-lg text-white/80">
                Conecte sua carteira digital, realize transações
                 e utilize todo o sistema Pix sem complicação.
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="flex justify-center m-8 mt-15 gap-4">
          <button
            onClick={openModal}
            className="bg-transparent h-14 border border-[#144dd2] text-white py-2 px-6 rounded-full "
          >
            Entre em contato
          </button>
          <button className="bg-[#887443] w-44 h-14 text-white py-2 px-6 rounded-full hover:bg-[#7A5F22]">
            <a
              href="https://www.linkedin.com/company/wiiascend/posts/?feedView=all"
              target="_blank"
              className="text-white rounded-full"
            >
              Saiba mais
            </a>
          </button>
        </div>

        <div
          className="flex justify-center items-center w-fit lg:w-[900px] bg-[#887443] lg:bg-[#081533] p-8 rounded-xl text-white mx-8 my-8"
          style={{
            background:
              "linear-gradient(to bottom, rgba(8, 21, 51, 0.8), rgba(8, 21, 51, 0.5), rgba(255, 255, 255, 0.2))",
          }}
        >

          <div className="flex lg:flex-row flex-col gap-4 items-center justify-center" >
            <div>
               <Icon name="Lock" className="text-white w-5 h-5 m-3" />
            </div>
            <h2 className="text-2xl  mb-4">Segurança <br />e Proteção:</h2>
            <p className="text-lg text-[#FAFAFA]/60">
              Na Wii Ascend, a segurança dos seus ativos é prioridade.
              <br /> Usamos criptografia AES-256, autenticação em dois fatores e 
              <br />monitoramento 24/7 para garantir a proteção de seus fundos.
            </p>
          </div>
        </div>
        
      </div>
      <Footer />
      <OptionModal isOpen={isModalOpen} closeModal={closeModal} />
    </div>
  );
};
